import { render, staticRenderFns } from "./router-loader.vue?vue&type=template&id=13df5680"
import script from "./router-loader.vue?vue&type=script&lang=js"
export * from "./router-loader.vue?vue&type=script&lang=js"
import style0 from "./router-loader.vue?vue&type=style&index=0&id=13df5680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports